import { render, staticRenderFns } from "./EmployeeSetting.vue?vue&type=template&id=44849ae4&scoped=true&"
import script from "./EmployeeSetting.vue?vue&type=script&lang=js&"
export * from "./EmployeeSetting.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeSetting.vue?vue&type=style&index=0&id=44849ae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44849ae4",
  null
  
)

export default component.exports